import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  margin: 8px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  margin-top: 36px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 20px;\n  row-gap: 20px;\n  width: 100%;\n\n  a {\n    border: 1px solid #a6a6a6;\n    border-radius: 7px;\n    background: #0c0d10;\n    mix-blend-mode: normal;\n    img {\n      border-radius: 7px;\n    }\n  }\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 30px;\n  text-align: center;\n  letter-spacing: 0.001em;\n  color: #beb7b7;\n  width: 300px;\n  span {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 30px;\n    text-align: center;\n    letter-spacing: 0.001em;\n    color: #beb7b7;\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: 45px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 20px;\n  row-gap: 20px;\n  width: 100%;\n  margin: 30px auto;\n  align-items: flex-start;\n  .container {\n    padding: 0px 130px;\n  }\n  @media screen and (max-width: 1200px) {\n    .container {\n      padding: 0px 150px 0px 105px;\n    }\n  }\n  @media screen and (max-width: 1200px) {\n    .container {\n      padding: 0 50px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: 575px) {\n    margin-top: 20px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { vars } from "@pancakeswap/ui/css/vars.css";
import React from "react";
import styled from "styled-components";
import { Text } from "../Text";
import { Link } from "../Link";
import { Text01 } from "../../../../../src/configs/fornt";
import { StyledFooter, StyledList } from "./styles";
import { useMatchBreakpoints } from "@pancakeswap/uikit";
var FooterItem = styled.div.withConfig({
    componentId: "sc-5e4a7613-0"
})(_templateObject());
var TextLink = styled(Text).withConfig({
    componentId: "sc-5e4a7613-1"
})(_templateObject1());
var ListImgButton = styled.div.withConfig({
    componentId: "sc-5e4a7613-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledTitle = styled(Text).withConfig({
    componentId: "sc-5e4a7613-3"
})(_templateObject3());
var BlockDownload = styled.div.withConfig({
    componentId: "sc-5e4a7613-4"
})(_templateObject4());
var BlockListItem = styled.div.withConfig({
    componentId: "sc-5e4a7613-5"
})(_templateObject5());
var ContactUs = styled.div.withConfig({
    componentId: "sc-5e4a7613-6"
})(_templateObject6());
var MenuItem = function(_param) {
    var items = _param.items, isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, cakePriceUsd = _param.cakePriceUsd, buyCakeLabel = _param.buyCakeLabel, props = _object_without_properties(_param, [
        "items",
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang",
        "cakePriceUsd",
        "buyCakeLabel"
    ]);
    var ref = useMatchBreakpoints(), isMobile = ref.isMobile, isTablet = ref.isTablet;
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        "data-theme": "dark",
        p: [
            "0px 16px",
            null,
            "0px 40px 32px 40px"
        ]
    }, props), {
        children: /*#__PURE__*/ _jsx(BlockListItem, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "container",
                style: {
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: isMobile ? "column" : "row"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "20px",
                            flexWrap: "wrap",
                            marginTop: isMobile ? "10px" : 0,
                            flexDirection: isMobile ? "column" : "row"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: "/images/core/Logo.png",
                                width: 100
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    display: isMobile ? "none" : "flex",
                                    background: "rgba(255, 255, 255, 0.10)",
                                    width: "1px",
                                    height: "16px"
                                }
                            }),
                            items === null || items === void 0 ? void 0 : items.map(function(item) {
                                var ref;
                                /*#__PURE__*/ return _jsx(StyledList, {
                                    children: (ref = item.items) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                                        var label = param.label, href = param.href, image = param.image, _isHighlighted = param.isHighlighted, isHighlighted = _isHighlighted === void 0 ? false : _isHighlighted, border = param.border;
                                        return /*#__PURE__*/ _jsxs("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                flexWrap: "wrap",
                                                justifyContent: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsxs(FooterItem, {
                                                    children: [
                                                        image && (border ? /*#__PURE__*/ _jsx("img", {
                                                            src: image,
                                                            style: {
                                                                marginRight: 12,
                                                                width: 24,
                                                                background: "#3b4858",
                                                                borderRadius: "50%",
                                                                fill: "black"
                                                            }
                                                        }) : /*#__PURE__*/ _jsx("img", {
                                                            src: image,
                                                            style: {
                                                                marginRight: 12,
                                                                width: 24
                                                            }
                                                        })),
                                                        href ? /*#__PURE__*/ _jsx(Link, {
                                                            "data-theme": "dark",
                                                            href: href,
                                                            target: item.label === "Home" ? "" : "_blank",
                                                            rel: "noreferrer noopener",
                                                            color: isHighlighted ? vars.colors.warning : "text",
                                                            bold: false,
                                                            children: /*#__PURE__*/ _jsx(TextLink, {
                                                                fontSize: 18,
                                                                children: label
                                                            })
                                                        }) : /*#__PURE__*/ _jsx(TextLink, {
                                                            children: label
                                                        })
                                                    ]
                                                }, href),
                                                /*#__PURE__*/ _jsx("div", {
                                                    style: {
                                                        display: isMobile ? "none" : "flex",
                                                        background: "rgba(255, 255, 255, 0.10)",
                                                        width: "1px",
                                                        height: "16px",
                                                        marginLeft: "20px"
                                                    }
                                                })
                                            ]
                                        });
                                    })
                                }, item.label);
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "30px"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "https://twitter.com/StakeCore",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: "/images/core/twitter.svg"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            display: isMobile ? "none" : "flex",
                                            background: "rgba(255, 255, 255, 0.10)",
                                            width: "1px",
                                            height: "16px"
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "https://t.me/corestakechannel",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: "/images/core/telegram.svg"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ContactUs, {
                        children: /*#__PURE__*/ _jsx(Text01, {
                            style: {
                                color: "rgba(255, 255, 255, 0.70)",
                                textAlign: "right",
                                /* Typo/Title Tiny */ fontFamily: "Poppins,sans-serif",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "20px"
                            },
                            children: "@copyright 2023"
                        })
                    })
                ]
            })
        })
    }));
};
export default MenuItem;
